import React from "react";
import SEO from "./SEO";

function trackEvent(action, label) {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: "Contact",
      event_label: label,
    });
  }
}

function Contact() {
  return (
    <section id="contact" className="contact" aria-labelledby="contact-title">
      <SEO
        title="Contact Sukun Cloud Consulting"
        description="Get in touch with Sukun Cloud Consulting for expert Cloud and DevOps services. Reach us via email, phone, WhatsApp, or LinkedIn."
        keywords={["Contact", "Cloud Consulting", "DevOps", "Sukun", "Email", "LinkedIn"]}
      />
      <h2 id="contact-title">Contact Us</h2>
      <p>
        We are here to provide expert Cloud and DevOps solutions. Feel free to reach out for inquiries, collaborations, or consultations.
      </p>
      <ul className="contact-details">
        <li>
          <strong>Email:</strong>{" "}
          <a
            href="mailto:contact@sukuncloud.com"
            onClick={() => trackEvent("contact_click", "Email")}
          >
            contact@sukuncloud.com
          </a>
        </li>
        <li>
          <strong>Phone (US):</strong>{" "}
          <a
            href="tel:+14434291717"
            onClick={() => trackEvent("contact_click", "Phone (US)")}
          >
            +1-443-429-1717
          </a>
        </li>
        <li>
          <strong>Phone (India):</strong>{" "}
          <a
            href="tel:+919546414991"
            onClick={() => trackEvent("contact_click", "Phone (India)")}
          >
            +91-95464-14991
          </a>
        </li>
        <li>
          <strong>WhatsApp:</strong>{" "}
          <a
            href="https://wa.me/919546414991"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("contact_click", "WhatsApp")}
          >
            Start a Chat
          </a>
        </li>
        <li>
          <strong>LinkedIn:</strong>{" "}
          <a
            href="https://linkedin.com/company/sukun-cloud-consultancy"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("contact_click", "LinkedIn")}
          >
            Visit Our LinkedIn Page
          </a>
        </li>
      </ul>
      <h3>Schedule a Consultation</h3>
      <p>
        Book a call with us through{" "}
        <a
          href="https://calendly.com/suresh-mahawar"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("contact_click", "Calendly")}
        >
          Calendly
        </a>{" "}
        or{" "}
        <a
          href="https://tidycal.com/suresh-mahawar"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("contact_click", "TidyCal")}
        >
          TidyCal
        </a>.
      </p>
    </section>
  );
}

export default Contact;